(function() {
    'use strict';

    angular
        .module('app.modals.datapointCustomConfig', [])
        .factory('datapointCustomConfigModal', ['ModalService', function (ModalService) {
            return function (Datapoint,Title) {
                return ModalService.showModal({
                    templateUrl: "views/modals/datapointCustomConfig.html",
                    controller: 'DatapointCustomConfigCtrl',
                    inputs: {
                        Datapoint: Datapoint,
                        Title : Title
                    }
                });
            };
        }])
        .controller('DatapointCustomConfigCtrl', DatapointCustomConfigCtrl)
        ;


    /* @ngInject */
    function DatapointCustomConfigCtrl($scope, close, Datapoint, Title, ENUM, $timeout, API, __DatapointConfig) {

        $scope.init = function() {
            $scope.userLevels = {};
            var userLevelsAll = ENUM.getEnum('BMSUserLevel')['1AsKey'];
            for (var lvl in userLevelsAll) {
                if (userLevelsAll.hasOwnProperty(lvl)) {
                    $scope.userLevels[lvl] = userLevelsAll[lvl].DisplayName;
                }
            }

            if (Datapoint.Config) {
                $scope.dpConfig = angular.copy(Datapoint.Config);
                $scope.dpConfig.UIElement = Datapoint.DatapointConfig.UIElement;
            } else {
                $scope.dpConfig = angular.copy(Datapoint.DatapointConfig);
            }

            if (Datapoint.DatapointConfig) {
                $scope.dpConfig.PossibleValues = Datapoint.DatapointConfig.PossibleValues;
            }

            $scope.Title = Title;
            $scope.isValueNumber = (typeof($scope.dpConfig.DefaultValue) === 'number');
            $scope.revertHappened = false;

            /* First turn all interaction to false so the GUI elements are correctly set to On/Off */
            $scope.interact = false;

            /* After the page loads set interaction to true so upon mouseover the switch to false is detected by a slider. */
            $timeout(function () {
                $scope.interact = true;
            }, 0);
        };

        $scope.close = function () {
            if ($scope.revertHappened) {
                close({ 'dpConfig': $scope.dpConfig, 'revertHappened': $scope.revertHappened });
            } else {
                close({ 'dpConfig': undefined, 'revertHappened': $scope.revertHappened });
            }
        };

        $scope.revertToDefault = function() {
            var api = new API();

            var params = {
                "DeviceId": Datapoint.DatapointValue.DeviceId,
                "ConfigId": $scope.dpConfig.DatapointConfigId
            };
            api.Datapoint.ClearCustomConfig(params).$promise
                .then(function() {
                    __DatapointConfig.$GetByIds([ Datapoint.DatapointConfig.DatapointConfigId ], Datapoint.DatapointConfig.DeviceType)
                    .$then(function(cleanDatapoint) {
                        for (var point in $scope.dpConfig) {
                            if ($scope.dpConfig.hasOwnProperty(point)
                            && point.lastIndexOf('$', 0) !== 0
                            && point.lastIndexOf('_', 0) !== 0
                            && point !== 'PossibleValues'
                            && cleanDatapoint[0][point] !== $scope.dpConfig[point]) {
                                $scope.dpConfig[point] = cleanDatapoint[0][point];
                            }
                        }

                        $scope.revertHappened = true;
                    });
                })
                .catch(function () {
                    console.warn('Error: clearing custom datapoint config failed');
                });
        };

        $scope.scopeInteraction = function(active) {
            $scope.interact = active;
        };

        $scope.save = function () {
            $scope.dpConfig.UserLevelRead = parseInt($scope.dpConfig.UserLevelRead, 10);
            $scope.dpConfig.UserLevelWrite = parseInt($scope.dpConfig.UserLevelWrite, 10);

            $scope.dpConfig.MinValue = parseValue($scope.dpConfig.MinValue);
            $scope.dpConfig.MaxValue = parseValue($scope.dpConfig.MaxValue);
            $scope.dpConfig.DefaultValue = parseValue($scope.dpConfig.DefaultValue);

            var api = new API();

            var configWithId = $scope.dpConfig;
            configWithId.DeviceId = Datapoint.DatapointValue.DeviceId;

            var saveCustomConfigParams = { "CustomDatapointConfig": configWithId };
            api.Datapoint.SetCustomConfig(saveCustomConfigParams).$promise
                .then(function () {
                    $scope.revertHappened = false;
                    close({ 'dpConfig': $scope.dpConfig, 'revertHappened': $scope.revertHappened });
                })
                .catch(function () {
                    console.warn('Error: saving custom datapoint config failed');
                });
        };

        function parseValue(value) {
            if (typeof(value) === 'number') {
                if (Number.isInteger(value)) {
                    return parseInt(value, 10);
                }
                else {
                    return parseFloat(value);
                }
            } else {
                return value;
            }
        }

        $scope.init();
    }

})();
